// import {
//   Id
// Request,
// RequestAgencyStatus,
// RequestTicket,
// RequestTicketType,
// ResponseDataPaginate
// } from 'src/types'

export enum AgreementOfferActionTypes {
  GET_AGREEMENT_OFFER = '@agreementOffer/GET_AGREEMENT_OFFER',
  GET_AGREEMENT_OFFER_FAILURE = '@agreementOffer/GET_AGREEMENT_OFFER_FAILURE',
  GET_AGREEMENT_OFFER_SUCCESS = '@agreementOffer/GET_AGREEMENT_OFFER_SUCCESS',
  SEND_AGREEMENT_OFFER = '@agreementOffer/SEND_AGREEMENT_OFFER',
  SEND_AGREEMENT_OFFER_FAILURE = '@agreementOffer/SEND_AGREEMENT_OFFER_FAILURE',
  SEND_AGREEMENT_OFFER_SUCCESS = '@agreementOffer/SEND_AGREEMENT_OFFER_SUCCESS'
}

export type ResponseDataRequests = {
  agency_partner_hotel_agreements: ResponseDataRequestsItem[]
}

export interface ResponseDataRequestsItem {
  agreement_id: number
  organization_id: number
  service_hub_id: number
  agreement_type: string
  integration_type: string
  name: string
  code: number
}

export type ResponseDataRequestTotals = {
  request_totals: {
    total_emissions: number
    total_quotations: number
  }
}

export type AgreementOfferState = ResponseDataRequestTotals & {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly sendAgreementOfferError: string
  readonly sendAgreementOfferLoading: boolean
  readonly total_results: number
}
